"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const GridElementWrapper = props => {
    const wid = (0, react_1.useRef)(Math.min((100 / props.columns) * props.columnSpan, 100));
    const [_tracker, setTracker] = (0, react_1.useState)(0);
    const FLEX_COLUMN_GAP = 15;
    const gapMultiplier = (0, react_1.useRef)(1);
    (0, react_1.useEffect)(() => {
        let w = Math.min((100 / props.columns) * props.columnSpan, 100);
        if (props.allowDynamicSizing) {
            if (window.innerWidth <= 480) {
                //Roughly mobile size, first iteration we will force 1 item per row
                w = 100;
            }
            else if (window.innerWidth <= 1024) {
                //Tablet range, first iteration, we will just double width of everything
                w = Math.min(100, w * 2);
            }
        }
        if (w !== wid.current) {
            wid.current = w;
            setTracker(v => v + 1);
        }
        const handleWindowResize = () => {
            let w = Math.min((100 / props.columns) * props.columnSpan, 100);
            if (props.allowDynamicSizing) {
                if (window.innerWidth <= 480) {
                    //Roughly mobile size, first iteration we will force 1 item per row
                    w = 100;
                }
                else if (window.innerWidth <= 1024) {
                    //Tablet range, first iteration, we will just double width of everything
                    w = Math.min(100, w * 2);
                }
                gapMultiplier.current = w === 100 ? 0 : 1;
            }
            if (w !== wid.current) {
                wid.current = w;
                setTracker(v => v + 1);
            }
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    const { children } = props;
    return (react_1.default.createElement("div", { style: {
            flexBasis: `calc(${wid.current}% - ${FLEX_COLUMN_GAP * gapMultiplier.current}px * (${props.columns - props.columnSpan}) / ${props.columns})`,
            flexShrink: 0,
            flexGrow: 1,
            overflowX: 'auto',
            overflowY: 'hidden',
        } },
        react_1.default.createElement("div", { style: props.noMargins
                ? {}
                : props.type === 'group'
                    ? { height: '100%' }
                    : (props.columns > 1 || props.isOneElement) && !props.isDesktopCard
                        ? {
                            marginRight: 8,
                            marginBottom: 8,
                        }
                        : {
                            marginRight: 15,
                            marginBottom: 0,
                        } }, children)));
};
exports.default = GridElementWrapper;
//# sourceMappingURL=GridElementWrapper.js.map